import { render } from "./DragCard5.vue?vue&type=template&id=74073647&scoped=true&ts=true"
import script from "./DragCard5.vue?vue&type=script&lang=ts"
export * from "./DragCard5.vue?vue&type=script&lang=ts"

import "./DragCard5.vue?vue&type=style&index=0&id=74073647&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74073647"]])

export default __exports__